import { render, staticRenderFns } from "./customDialog.vue?vue&type=template&id=a3400b06&"
import script from "./customDialog.vue?vue&type=script&lang=ts&"
export * from "./customDialog.vue?vue&type=script&lang=ts&"
import style0 from "./customDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports